module.exports = __webpack_public_path__ + "img/TestPanelDMPEnActivacion.9c6f990a.svg";